import styled from "styled-components";
import { colors } from "@/theme";

export const ShippingAddressDetailsContainer = styled.div``;

export const ShippingAddressDetailsTitle = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 8px;
`;

export const ShippingAddressDetailsSubtitle = styled.div`
  color: ${colors.fieldTextHelper};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const ShippingAddressDetailsInputsContainer = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr 1fr 1fr;
  column-gap: 12px;
`;

export const ShippingAddressDetailsInput = styled.div``;
